<div class="label" [@fade] *ngIf="hasTitle()">
    <div class="label-title" id="page-header-context-label">
        {{title}}
    </div>
</div>
<div class="description" [@fade] *ngIf="hasDescription()">
    <div class="description-title" id="page-header-context-description">
        {{description}}
    </div>
</div>
